var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"v-image-skeleton",style:({ height: _vm.props.height ? ((_vm.props.height) + "px") : 'auto' })})}
var staticRenderFns = []

export { render, staticRenderFns }